import { StaticImage } from "gatsby-plugin-image"

import { Trans } from "@trueskin-web/translations"

import Card from "./card"

const PhotoUpload = () => (
  <Card dataTestId="wb-steps-photos">
    <div
      sx={{
        display: "flex",
        columnGap: 2,
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Trans i18nKey="Start.WelcomeBack.Steps.PhotoUpload.description" />
      <StaticImage
        src="./images/photos_3x.webp"
        alt=""
        height={36}
        sx={{ flexShrink: 0 }}
      />
    </div>
  </Card>
)

export default PhotoUpload
